import ImageOne from '../../assets/images/main/ascari-building-contractors-landscaping-and-carpentry-frame-small.jpg';
import ImageThree from '../../assets/images/main/ascari-building-contractors-landscaping-and-carpentry-interior.jpg';
import ImageFour from '../../assets/images/main/ascari-building-contractors-bathroom-hero.avif';
import ImageFive from '../../assets/images/main/ascari-building-contractors-landscaping-and-carpentry-roofing-unfinished.jpg';

export const fullServicesArray = [
  {
    label: 'Carpentry',
    imageUrl: ImageThree,
    subcategories: [
      'Decking',
      'Flooring',
      'Stairs',
      'Roofing',
      'Timber Frame',
      'Kitchens',
      'First Fix Carpentry',
      'Second Fix Carpentry',
    ],
  },
  {
    label: 'Bathrooms',
    imageUrl: ImageFour,
    subcategories: ['New Installations', 'Rip Out and Refit'],
  },
  {
    label: 'Groundworks',
    imageUrl: ImageOne,
    subcategories: [
      'Footings',
      'Concrete Slabs',
      'Driveways',
      'Landscaping',
      'Fencing',
      'Retaining Walls',
      'Stonework',
      'Blockwork',
      'Drainage',
      'Earth Moving',
      'Patios',
    ],
  },
  {
    label: 'Building Work & General Construction',
    imageUrl: ImageFive,
    subcategories: [
      'New Builds',
      'Extensions',
      'Full-Service Construction',
      'Over 20 Years of Experience',
    ],
  },
];
